import React from "react";
import styled from "styled-components";

import { FlexBox, ObjectiveText } from "@examspark/common-ui";
import { Objective } from "@examspark/types";

const ListItem = styled(FlexBox)`
  padding: 1rem;
  border-top: solid 1px #ddd;
  gap: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
  flex-direction: row;

  &:hover {
    background-color: #f7f7f7;
  }
  &:first-child {
    border-top: none;
  }
`;
const ListItemSelect = styled.div`
  width: 3rem;
`;
const ListItemContent = styled.div`
  flex: 1;
`;
const ListItemCount = styled.div`
  width: 4rem;
`;
const Count = styled.div`
  background-color: #006699;
  color: #fff;
  border-radius: 1rem;
  text-align: center;
  padding: 0.4rem 0.5rem;
  margin: -0.3rem 0;
  font-size: 1rem;
`;

interface Props {
  objective: Objective;
  count: number;
  checked?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  highlightText?: string;
}

const ObjectiveSelectListItem: React.FC<React.PropsWithChildren<Props>> = (
  props,
) => {
  return (
    <ListItem onClick={props.onClick}>
      <ListItemSelect>
        <input
          type="checkbox"
          checked={props.checked}
          disabled={props.disabled}
          onChange={() => {
            //
          }}
        />
      </ListItemSelect>
      <ListItemContent>
        <ObjectiveText
          objective={props.objective}
          highlightText={props.highlightText}
        />
      </ListItemContent>
      <ListItemCount>
        <Count>{props.count}</Count>
      </ListItemCount>
    </ListItem>
  );
};

export default ObjectiveSelectListItem;
